module.exports = __webpack_public_path__ + "img/logo.c743a5bd.png";